import { c as _c } from "react/compiler-runtime";
import { runtimeConfig } from "@src/runtime-config";
import { StellarApiClient } from "@stellar/stellar-api-client";
import { getDashboard20ApiUrl } from "@utils/url-utils";
import { useMemo } from "react";
/**
 * Hook that provides access to the Stellar API client.
 */
export function useStellarApiClient() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const baseUrl = getDashboard20ApiUrl(runtimeConfig.urls.dashboard20Api, runtimeConfig.numberedEnv);
    t0 = new StellarApiClient({
      baseUrl
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const stellarApiClient = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      stellarApiClient
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}